import { useHasCustomTypes } from "../documents/DocumentListBody/useHasCustomTypes"

export function useShouldDisplayOnboarding() {
  return !useHasCustomTypes()
}
